module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-sample-05.f94409a1.jpg";